import React, { useState, useEffect } from 'react';
import { adminService } from '../services/adminService';
import './VistaComo.css';

// Baja de un usuario desde el home del superadmin. Primero muestra el simulacro
// del backend (qué se borra) y pide escribir el email para confirmar. El proceso
// es el mismo de scripts/dar-de-baja.js: al terminar le llega el mail de baja.

function textoMercadoPago(plan) {
    if (!plan.collectorId) return 'No tiene cuenta de Mercado Pago conectada.';
    if (!plan.cuenta) return 'No hay token de Mercado Pago guardado para su cuenta.';
    if (plan.borrarCuenta) return 'Se borra el token de Mercado Pago: nadie más usa esa cuenta.';
    return `La cuenta de Mercado Pago queda, porque la usan también: ${plan.otros.join(', ')}.`;
}

function BajaUsuarioModal({ email, onClose, onBajaHecha }) {
    const [plan, setPlan] = useState(null);
    const [error, setError] = useState(null);
    const [confirmacion, setConfirmacion] = useState('');
    const [aplicando, setAplicando] = useState(false);
    const [hecha, setHecha] = useState(false);

    useEffect(() => {
        if (!email) return undefined;

        let vigente = true;
        setPlan(null);
        setError(null);
        setConfirmacion('');
        setHecha(false);
        adminService.simularBaja(email)
            .then((p) => vigente && setPlan(p))
            .catch((e) => vigente && setError(e.message));
        return () => {
            vigente = false;
        };
    }, [email]);

    if (!email) return null;

    const confirmado = confirmacion.trim().toLowerCase() === email.toLowerCase();

    const aplicar = async () => {
        setAplicando(true);
        setError(null);
        try {
            await adminService.darDeBaja(email, confirmacion.trim());
            setHecha(true);
            onBajaHecha([...plan.operadores, plan.email]);
        } catch (e) {
            setError(e.message);
        } finally {
            setAplicando(false);
        }
    };

    const cerrar = () => {
        if (!aplicando) onClose();
    };

    return (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && cerrar()}>
            <div className="modal-content baja-modal">
                <div className="modal-header">
                    <h2>Dar de baja</h2>
                    <button className="close-button" onClick={cerrar}>×</button>
                </div>

                {!plan && !error && <p className="baja-modal__nota">Calculando qué se borra…</p>}

                {plan && (
                    <>
                        <p className="baja-modal__usuario">
                            <strong>{plan.nombre || plan.email}</strong>
                            <span>{plan.email}{plan.negocio && ` · ${plan.negocio}`}</span>
                        </p>
                        <ul className="baja-modal__lista">
                            <li>Se borran su usuario y su login.</li>
                            {plan.operadores.length > 0 && (
                                <li>
                                    Se borran {plan.operadores.length === 1 ? 'su operador' : `sus ${plan.operadores.length} operadores`}:{' '}
                                    {plan.operadores.join(', ')}.
                                </li>
                            )}
                            <li>{textoMercadoPago(plan)}</li>
                            <li>Le llega un mail confirmando la baja.</li>
                        </ul>
                    </>
                )}

                {error && <div className="error-message">{error}</div>}
                {plan?.bloqueo && !error && <div className="error-message">{plan.bloqueo}</div>}

                {hecha ? (
                    <>
                        <div className="success-message">
                            Listo: {plan.email} quedó dado de baja. El mail de confirmación sale solo.
                        </div>
                        <div className="baja-modal__acciones">
                            <button className="baja-modal__cancelar" onClick={onClose}>Cerrar</button>
                        </div>
                    </>
                ) : plan && !plan.bloqueo && (
                    <>
                        <label className="baja-modal__label" htmlFor="baja-confirmacion">
                            No se puede deshacer. Para confirmar, escribí el email del usuario.
                        </label>
                        <input
                            id="baja-confirmacion"
                            type="text"
                            className="baja-modal__input"
                            placeholder={email}
                            value={confirmacion}
                            onChange={(e) => setConfirmacion(e.target.value)}
                            autoComplete="off"
                        />
                        <div className="baja-modal__acciones">
                            <button className="baja-modal__cancelar" onClick={cerrar} disabled={aplicando}>
                                Cancelar
                            </button>
                            <button className="baja-modal__confirmar" onClick={aplicar} disabled={!confirmado || aplicando}>
                                {aplicando ? 'Dando de baja…' : 'Dar de baja'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default BajaUsuarioModal;
